/**
 * @fileoverview GET handler for the "/app_settings/:app_group_id/quiet_hours/rules" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAppGroupIdQuietHoursRulesData } from "./constants";
import type {
  AppSettingsAppGroupIdQuietHoursRulesDataResult,
  GetAppSettingsAppGroupIdQuietHoursRulesDataParams,
} from "./types";
import { isAppSettingsAppGroupIdQuietHoursRulesDataResult } from "./validators";

export const getAppSettingsAppGroupIdQuietHoursRulesData = reactQueryFetcherAdapter(
  appSettingsAppGroupIdQuietHoursRulesData,
  (
    signal: AbortSignal,
    { appGroupId }: GetAppSettingsAppGroupIdQuietHoursRulesDataParams
  ): Promise<AppSettingsAppGroupIdQuietHoursRulesDataResult> => {
    return fetch(`/app_settings/${appGroupId}/quiet_hours/rules`, "GET", {}, { signal });
  },
  isAppSettingsAppGroupIdQuietHoursRulesDataResult
);
